<template>
<div class="introduction">
<br>
<p>「開放取用週 (Open Access Week, OA Week)」是一項推廣開放取用的全球性活動，全球學術和研究社群皆利用此一機會學習與分享開放取用的相關議題，並宣導開放取用成為學術與研究的新典範。</p>
<p>「開放取用週」是一個寶貴的機會，將「開放、分享」的全球趨勢介紹給國內的學術和研究社群。大學、學院、研究機構、研究計畫資助機構、圖書館以及智庫都使用「開放取用週」作為平台，對服務社群推廣開放取用、推動開放取用政策、公布開放取用相關社會和經濟效益的報告等等。</p>
<p>有鑑於「開放取用週」在國外已行之有年，但在臺灣則較少有大學及研究機構圖書館推動，因此中華圖書資訊館際合作協會乃配合這股浪潮，於今年在國內推動「開放取用週2021 (OA Week 2021)」，期盼各會員單位踴躍參加。</p>
</div>
</template>

<script>
export default {
  name: 'Introduction'
}
</script>

<style lang="css" scoped>
.introduction {
padding-top:20px;
background-color: rgba(248, 194, 88,0.1);
box-shadow: 0 5px 5px -2px rgba(0,0,0,.2);

}
@media only screen and (max-width: 600px) {
    .introduction {padding-bottom:50px}
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
    .introduction {padding-bottom:50px}
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
    .introduction {padding-bottom:90px}
}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
    .introduction {padding-bottom:100px}
}
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
    .introduction {padding-bottom:100px}
}
p {
font-family: Microsoft JhengHei;
font-size: 20px;
font-weight: 500;
text-indent: 2em;
margin-left: 60px;
margin-right: 60px;
text-align: justify;
}
</style>
